// navigation - main :

    // burger menu animation :

   /*      document.addEventListener('DOMContentLoaded', function () {
            var navbarToggler = document.querySelector('.navbar-toggler');
            var animatedIcon = document.querySelector('.animated-icon');
        
            navbarToggler.addEventListener('click', function () {
                animatedIcon.classList.toggle('open');
            });
        });
 */

/*         document.addEventListener('DOMContentLoaded', function () {
            var navbarToggler = document.querySelector('.navbar-toggler');
            var animatedIcon = document.querySelector('.animated-icon');
            var navbarBackBtn = document.querySelector('.navbar-back-btn');
        
            navbarToggler.addEventListener('click', function () {
                animatedIcon.classList.toggle('open');
                if (navbarBackBtn) {
                    navbarBackBtn.classList.toggle('open');
                }
            });
        });
 */
        document.addEventListener('DOMContentLoaded', function () {
            var navbarToggler = document.querySelector('.navbar-toggler');
            var animatedIcon = document.querySelector('.animated-icon');
            var navbarBackBtn = document.querySelector('.navbar-back-btn');
            var phoneContainer = document.querySelector('.phone-container');
            var pricingContainer = document.querySelector('.pricing-container');
        
            function toggleMenu() {
                // Animacja ikony burgera
                animatedIcon.classList.toggle('open');
                
                // Zmiana klasy na back-btn
                if (navbarBackBtn) {
                    navbarBackBtn.classList.toggle('open');
                }
        
                // Ukrywanie elementów, gdy menu jest otwarte
                if (animatedIcon.classList.contains('open')) {
                    if (phoneContainer) {
                        phoneContainer.style.display = 'none';
                    }
                    if (window.innerWidth < 1199 && pricingContainer) {
                        pricingContainer.style.display = 'none';
                    }
                } else {
                    // Pokazywanie elementów, gdy menu jest zamknięte
                    if (window.innerWidth < 1199 && pricingContainer) {
                        pricingContainer.style.display = '';
                    }
                    if (phoneContainer) {
                        phoneContainer.style.display = '';
                    }
                }
            }
        
            // Obsługa kliknięcia na przycisk burgera
            navbarToggler.addEventListener('click', toggleMenu);
        
            // Obsługa kliknięcia na przycisk powrotu - zamyka menu tylko jeśli jest otwarte
            if (navbarBackBtn) {
                navbarBackBtn.addEventListener('click', function () {
                    if (animatedIcon.classList.contains('open')) {
                        toggleMenu();
                    }
                });
            }
        });

    // navbar shadow:

        function handleScroll() {
          const navigation = document.querySelector('.navigation-main');
          
          if (window.scrollY > 80) {
              navigation.classList.add('navbar-shadow');
          } else {
              navigation.classList.remove('navbar-shadow');
          }
        }

        window.addEventListener('scroll', handleScroll);


    // removing .active classes added by wordpress when anchor links are in the menu :

        document.addEventListener("DOMContentLoaded", function() {
            const links = document.querySelectorAll(".nav-link[href^='/#']");
          
            links.forEach(link => {
              if (link.classList.contains("active")) {
                link.classList.remove("active");
              }
            });
          });